/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    organizationName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    regionCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    mobilePhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    email?: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): boolean {
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'] == null ? undefined : json['regionCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'mobilePhoneNumber': json['mobilePhoneNumber'] == null ? undefined : json['mobilePhoneNumber'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function AddressToJSON(value?: Address | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'organizationName': value['organizationName'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'country': value['country'],
        'phoneNumber': value['phoneNumber'],
        'mobilePhoneNumber': value['mobilePhoneNumber'],
        'email': value['email'],
    };
}

